import { API_ENDPOINTS } from "../config/api/apiCall";
import { Warehouse_API_ENDPOINTS } from "../config/api/apiCallWarehouse";
import { callApi } from "../utils/apiClient";

export const loadWarehouseTypeList = async (para) => {
    try {
        const payload = {

            p_company_id: localStorage.getItem('companyid') || 0,
            p_plant_id: 1,
        };

        return await callApi(Warehouse_API_ENDPOINTS.warehouseType.list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading warehouse type list:", error);
        throw error;
    }
};

export const loadWarehouseEnvironmentList = async (para) => {
    try {
        const payload = {

            p_company_id: localStorage.getItem('companyid') || 0,
            p_plant_id: 1,
        };
        return await callApi(Warehouse_API_ENDPOINTS.environmentType.list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading warehouse environment list:", error);
        throw error;
    }
};

export const loadWarehouseBinTypeList = async (para) => {
    try {
        const payload = {

            p_company_id: localStorage.getItem('companyid') || 0,
            p_plant_id: 1,
        };
        return await callApi(Warehouse_API_ENDPOINTS.binType.list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading warehouse bin type list:", error);
        throw error;
    }
};

export const loadWarehouseList = async (para) => {
    try {
        const payload = {
            p_company_id: localStorage.getItem('companyid') || 0,
            p_plant_id: 1,
        };
        return await callApi(Warehouse_API_ENDPOINTS.warehouse.list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading warehouse list:", error);
        throw error;
    }
};

export const loadBintypeList = async (para) => {
    try {
        const payload = {
            p_company_id: localStorage.getItem('companyid') || 0,
            p_plant_id: 1,
        };
        return await callApi(Warehouse_API_ENDPOINTS.binType.list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading bin type list:", error);
        throw error;
    }
};

export const loadStorageLocationtypeList = async (para) => {
    try {
        const payload = {
            p_company_id: localStorage.getItem('companyid') || 0,
            p_plant_id: 1,
        };
        return await callApi(Warehouse_API_ENDPOINTS.locationType.list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading location type list:", error);
        throw error;
    }
};


export const loadStorageLocationList = async (para) => {
    try {
        const payload = {
            p_company_id: localStorage.getItem('companyid') || 0,
            p_plant_id: 1,
        };
        return await callApi(Warehouse_API_ENDPOINTS.storageLocation.list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading location type list:", error);
        throw error;
    }
};


export const loadStorageLocationListByID = async (payload) => {
    try {
       
        return await callApi(Warehouse_API_ENDPOINTS.storageLocation.getById, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading location type list:", error);
        throw error;
    }
};


export const loadPackagetypeBySONumber = async (payload) => {
    try {
       
        return await callApi(API_ENDPOINTS.PRODUCTION_packagetype_list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading location type list:", error);
        throw error;
    }
};

export const warehouselocationBinusage = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.fgWarehouse.location_bin_usage, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading location type list:", error);
        throw error;
    }
};


export const loadWarehousetypeListByStatus = async (payload) => {
    try {      
        return await callApi(Warehouse_API_ENDPOINTS.warehouseType.getListByStatus, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading bin type list:", error);
        throw error;
    }
};

export const loadWarehouseEnvironmenttypeListByStatus = async (payload) => {
    try {        
        return await callApi(Warehouse_API_ENDPOINTS.environmentType.getListByStatus, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading bin type list:", error);
        throw error;
    }
};

export const loadWarehousListByStatus = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.warehouse.getListByStatus, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading bin type list:", error);
        throw error;
    }
};

export const loadWarehouseLocationtypeListByStatus = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.locationType.getListByStatus, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading bin type list:", error);
        throw error;
    }
};

export const loadWarehouseBintypeListByStatus = async (payload) => {
    try {      
        return await callApi(Warehouse_API_ENDPOINTS.binType.getListByStatus, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading bin type list:", error);
        throw error;
    }
};


export const loadWarehouseObjecttypeListByStatus = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.objectType.getListByStatus, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading bin type list:", error);
        throw error;
    }
};


export const loadWarehouseDataReportList = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.warehouseReport.master_report, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading master report data list:", error);
        throw error;
    }
};

export const loadProductionReportListByDateRange = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.warehouseReport.filter_production_date_range_report, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading master report data list:", error);
        throw error;
    }
};

export const RefreshDataReportList = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.warehouseReport.refresh_report, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading master report data list:", error);
        throw error;
    }
};



//

export const GetStockSummary = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.warehouseDashboard.stock_summary, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading master report data list:", error);
        throw error;
    }
};

export const GetStockInward = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.warehouseDashboard.inward_shipment, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading master report data list:", error);
        throw error;
    }
};

export const GetStockOutward = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.warehouseDashboard.outward_shipment, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading master report data list:", error);
        throw error;
    }
};

export const GetStockInwardAndOutward = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.warehouseDashboard.inward_outward_shipment, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading master report data list:", error);
        throw error;
    }
};


export const SOWiseLocationList = async (payload) => {
    try {       
        return await callApi(Warehouse_API_ENDPOINTS.fgWarehouse.so_wise_location_list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading location type list:", error);
        throw error;
    }
};








